import { gql } from '@apollo/client';
import { WarrantyInfoShared } from '../fragments';

export default gql`
  query warranty($id: ID!) {
    warranty(id: $id) {
      ...WarrantyInfoShared
    }
  }
  ${WarrantyInfoShared}
`;
